var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"facilitatorImage",attrs:{"src":require(("./../assets/facilitator_drawings/" + (_vm.toolkit.link) + "_" + _vm.number + ".png")),"alt":_vm.$t('altText.facilitator')}})}
var staticRenderFns = []

export { render, staticRenderFns }